import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'antd/lib/button';
import { FormattedMessage } from 'react-intl';
import { BarsOutlined, PlusOutlined } from '@ant-design/icons';

import { Row, Col } from 'antd/lib/grid';
import { useHistory } from 'react-router';
import { useFela } from 'react-fela';

import config from 'config/index';

import InfoList from '../../containers/Info/InfoList';
import DeleteInfoCategory from '../../containers/InfoCategories/DeleteInfoCategory';

import rule from './InfoCategory.rule';

const infoCategoryPropTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};

export const infoCategoryShape = PropTypes.shape(infoCategoryPropTypes);

const InfoCategory = ({ name, id }) => {
    const history = useHistory();
    const { css } = useFela();

    return (
        <div className={css(rule)}>
            <Row type="flex">
                <Col className="dragger" span={1}>
                    <BarsOutlined />
                </Col>
                <Col className="draggable" span={23}>
                    <h3>
                        <Link to={config.routes.infoCategoriesDetail.replace(':id', id)}>{name}</Link>
                        <DeleteInfoCategory className="delete-info-category" id={id} size="small" />
                    </h3>
                    <InfoList id={id} />
                    <Button
                        className="add-info"
                        icon={<PlusOutlined />}
                        size="small"
                        onClick={() => {
                            history.push(config.routes.infoAdd.replace(':id', id));
                        }}
                    >
                        <FormattedMessage id="info.page.add.info" />
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

InfoCategory.propTypes = infoCategoryPropTypes;

export default InfoCategory;
